import type { PageView } from '../page-view.model';

export interface DonateImpact {
  _id?: string;
  amount: number;
  title?: string;
  name?: string;
  frequency?: string;
  currency?: string;
}

const ONE_OFF = 'one-off';

export function donateUrlOf(page: PageView, impact?: DonateImpact): string {
  const params = new URLSearchParams({ ref: 'campaign' });
  if (page.campaign?._id) params.set('campaign', page.campaign._id);
  if (page.team) params.set('team', page.team._id);
  if (page.fundraiser) params.set('fundraiser', page.fundraiser._id);

  if (impact) {
    if (impact._id) params.set('impact', impact._id);
    params.set('amount', String(impact.amount));
    params.set('title', impact.title || impact.name || '');
    if (impact.frequency && impact.frequency !== ONE_OFF) params.set('frequency', impact.frequency);
    if (impact.currency) params.set('currency', impact.currency);
  }
  return `/checkout?${params.toString()}`;
}

export function endedLabelOf(page: PageView): string | null {
  const campaign = page.campaign as { status?: string } | undefined;
  if (campaign?.status === 'ended') return 'Campaign ended';
  if (page.fundraiser?.status === 'ended') return 'Fundraiser ended';
  if (page.team?.status === 'ended') return 'Team ended';
  return null;
}
